import React from 'react';

const AccessRestricted = () => (
  <div className="general-info-page page-content-container">
    <div className="general-info-text">
      <span className="font-weight-bold">Access Restricted</span><br/>
      Additional access is required to view this provision.
    </div>
  </div>
);

export default AccessRestricted;
